exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body.modal-open{\n    overflow: hidden;\n}\n@media screen and (min-width: 768px) {\n    body.modal-open {\n        margin-right:1.7rem;\n    }\n}\n", ""]);

// exports
